﻿import {useBindSearchParam} from "../useBindSearchParam";
import {SearchSupplierSortType} from "../../types/supplier/SearchSupplierSortType";

export const useSortBySearchParam: (defaultValue: SearchSupplierSortType) => [SearchSupplierSortType, (newValue: SearchSupplierSortType) => void] = (defaultValue: SearchSupplierSortType) => {
    return useBindSearchParam<SearchSupplierSortType>('sortBy', defaultValue);
}
